<template>
  <!-- <van-pull-refresh v-model="isLoading" @refresh="onRefresh"> -->
    <div class="bottom-safe">
    <MySwipe
      :slug="slug"
    />
    <div class="van-hairline--bottom" style="background:#fff">
      <van-tag mark type="primary">编辑推荐</van-tag>
      <episode-list
        :slug="slug"
        :editorChoiceOnly="true"
        :premiumOnly="false"
        :limit="5"
      />
    </div>
    <!-- <div
      class="van-hairline--top van-hairline--bottom block top-space"
      :style="{'display':''}"
    >
      <van-tag mark type="warning">热门评论</van-tag>
      <hot-comments
        :slug="slug"
        :limit="3"
        @gotHotComments="gotHotComments"
      />
    </div> -->
    <!-- <div class="van-hairline--top van-hairline--bottom block">
      <div style="padding:16px;">
        <van-image
          radius="5"
          width="750rpx"
          height="397rpx"
          fit="contain"
          src="https://media-1301007541.file.myqcloud.com/images/sale-zone.jpg"
          @click="saleZone"
        />
      </div>
    </div> -->
    <div
      class="van-hairline--top van-hairline--bottom block"
      v-if="categoryListShow"
    >
      <div style="padding:16px 16px 0 16px;">
        <van-image
          radius="5"
          width="750rpx"
          height="397rpx"
          fit="contain"
          src="https://media-1301007541.file.myqcloud.com/images/sale-zone.jpg"
          @click="saleZone"
        />
      </div>
      <CategoryList
        :slug="slug"
        v-on:categoriesCount="gotCategoriesCount"
      />
    </div>
    <div class="van-hairline--top van-hairline--bottom block top-space">
      <van-tag mark type="success">最新节目</van-tag>
      <episode-list
        :slug="slug"
        :editorChoiceOnly="false"
        :premiumOnly="false"
        :limit="0"
      />
    </div>
    <!-- <ShowDetailTabbar :slug="slug" /> -->
  </div>
  <!-- </van-pull-refresh> -->
</template>

<script>
  import MySwipe from './my-swipe.vue'
  import EpisodeList from './episode-list.vue'
  import CategoryList from './category-list.vue'
  // import HotComments from './hot-comments.vue'
  // import { PullRefresh } from 'vant'
  // import Vue from 'vue'

  // Vue.use(PullRefresh)
  // import ShowDetailTabbar from './show-detail-tabbar.vue'

  export default {
    // inject: ['reload'],
    name: "ShowDetail",
    components: {
      MySwipe,
      EpisodeList,
      CategoryList,
      // HotComments
    },
    data () {
      return {
        slug: '', // show 的 slug
        hotCommentsCount: 0,
        // isLoading: false,
        // reload: false // 是否重新载入
        categoryListShow: true
      }
    },
    methods: {
      gotHotComments (hotCommentsCount) {
        window.console.log("父组件接收到热门评论数量")
        window.console.log(hotCommentsCount)
        this.hotCommentsCount = hotCommentsCount
      },
      gotCategoriesCount (count) {
        window.console.log("栏目的数量")
        window.console.log(count)
        if (count > 0) {
          this.categoryListShow = true
        } else {
          this.categoryListShow = false
        }
      },
      saleZone () {
        window.console.log("打折专区")
        this.$router.replace({
          name: 'SaleEpisodes',
          params: {
            slug: this.slug
          }
        })
      }
      // onRefresh() {
      //   setTimeout(() => {
      //     this.isLoading = false;
      //     // this.reload()
      //     // window.console.log(this.$refs.topBanner)
      //     // this.$refs.topBanner.reload()
      //     // this.$refs.editorChoice.reload()
      //   }, 1000);
      // }
    },
    mounted () {
      this.slug = this.$route.params.slug
    }
  }
</script>

<style lang="css" scoped>
  .top-space {
    padding-top:10px;
  }
  .block {
    margin-top:10px;
    background:#fff
  }
</style>
